export class StatusControleLancamento {
  static IdCadastrado = 'C7FC59D7-1F2F-4AC7-AA64-42D2C47D4D4A';
  static IdEnviadoAnalise = '8703EFD3-2A8B-4DA1-8954-D0FBD64712FB';
  static IdAprovadoGestorUnidade = '94A6AA64-23C6-4781-8205-17D61D938192';
  static IdAprovadoAdministrativoDex = '5FFCB085-AA2A-4F60-9428-83A86CC771E9';
  static IdAprovadoGestorDex = '8601C6B6-5310-4D56-9105-FBEFD8886603';
  static IdDevolvidoAjustes = '34E3379C-DBF9-4C71-AA89-19FC30AF47EE';
}




// WEBPACK FOOTER //
// ./src/app/models/statusControleLancamento.ts